import { useState } from 'react';
import { ChowLogo, LargeLogo } from '../assets/images';
import '../styles/Navbar.css';

// Hamburger menu icon
const HamburgerIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/>
    </svg>
);

// Close icon for mobile menu
const CloseIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
    </svg>
);

interface NavItem {
    label: string;
    url: string;
}

const Navbar = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const navItems: NavItem[] = [
        { label: 'Home', url: 'https://www.openscore.org.uk/' },
        { label: 'The Data', url: 'https://www.openscore.org.uk/data' },
        { label: 'Care Seekers', url: 'https://www.openscore.org.uk/care-seekers' },
        { label: 'Care Providers', url: 'https://www.openscore.org.uk/care-homes' }
    ];

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const handleNavClick = (url: string) => {
        window.open(url, '_self', 'noopener,noreferrer');
        setIsMobileMenuOpen(false); // Close mobile menu after navigation
    };

    return (
        <nav className="navbar">
            <div className="navbar-container">
                {/* Logo section */}
                <div className="navbar-logo">
                    <img 
                        src={LargeLogo} 
                        alt="Open Score Logo" 
                        className="logo-image"
                    />
                    <a
                        href="https://www.championingsocialcare.org.uk/care-home-open-week/about/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="navbar-support"
                        aria-label="Open the Care Home Open Week page"
                    >
                        <img
                            src={ChowLogo}
                            alt="Care Home Open Week"
                            className="navbar-support-image"
                        />
                        <div className="navbar-support-copy">
                            <span className="navbar-support-prefix">Proudly supporting</span>
                            <span className="navbar-support-title">Care Home Open Week</span>
                            <span className="navbar-support-dates">15th to 21st June 2026</span>
                        </div>
                    </a>
                </div>

                {/* Right side container for menu and mobile toggle */}
                <div className="navbar-right">
                    {/* Desktop navigation menu */}
                    <div className="navbar-menu">
                        {navItems.map((item, index) => (
                            <button
                                key={index}
                                className="navbar-item"
                                onClick={() => handleNavClick(item.url)}
                                aria-label={item.label}
                            >
                                <span>{item.label}</span>
                            </button>
                        ))}
                    </div>

                    {/* Mobile menu toggle */}
                    <button 
                        className="mobile-menu-toggle"
                        onClick={toggleMobileMenu}
                        aria-label="Toggle mobile menu"
                        aria-expanded={isMobileMenuOpen}
                    >
                        {isMobileMenuOpen ? <CloseIcon /> : <HamburgerIcon />}
                    </button>
                </div>
            </div>

            {/* Mobile navigation menu */}
            <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
                {navItems.map((item, index) => (
                    <button
                        key={index}
                        className="mobile-menu-item"
                        onClick={() => handleNavClick(item.url)}
                        aria-label={item.label}
                    >
                        <span>{item.label}</span>
                    </button>
                ))}
            </div>
        </nav>
    );
};

export default Navbar;
